import { TableBody, TableCell, TableHead, TableRow } from "@mui/material"
import { CustomPagination } from "../common/CustomPagination"
import { StickyTable } from "../common/StickyTable"
import { TableSkeleton } from "../skeletons/TableSkeleton"
import { CustomTableCell } from "../common/CustomTableCell"
import { Department_Headers, NOT_APPLICABLE } from "../../constants"
import { DepartmentListingProps } from "../../interfaceTypes/props"
import DepartmentMenu from "../menus/Department"

const DepartmentListing = ({ departments, loading , refetch} : DepartmentListingProps) => {
  return (
    <StickyTable pagination={<CustomPagination loading={loading} />} height="370px">
      <TableHead>
        <TableRow hover>
          {Department_Headers.map((columnName, index) => 
            <TableCell 
              key={index} 
              component="th" 
              align={'left'} 
              width={index === Department_Headers.length - 1 ? '100px' : 'auto'} 
            >
              {columnName}
            </TableCell>
          )}
        </TableRow>
      </TableHead>
          
      { loading ?         
          <TableSkeleton noOfRows={7} noOfCols={Department_Headers.length} />
        : 
          <TableBody>
            {departments?.map((department) => {
              const { id, name, description, departmentHead, departmentToLawTypes } = department || {}
              const { firstName, lastName } = departmentHead ?? {}
              const practiceAreas = departmentToLawTypes?.map(({ lawType }) => {
                const { name } = lawType ?? {}
                return name
              })

              return (
                <TableRow key={id} hover>
                  <CustomTableCell value={name} maxWidth="376px" />
                  
                  <CustomTableCell value={firstName && lastName ? `${firstName} ${lastName}`:  NOT_APPLICABLE} maxWidth="376px" />
                
                  <CustomTableCell value={practiceAreas?.join(', ') || NOT_APPLICABLE} maxWidth="376px" />
                
                  <CustomTableCell value={description || NOT_APPLICABLE} maxWidth="450px" />
                
                  <TableCell>
                    <DepartmentMenu department={department} refetch={refetch} />
                  </TableCell>
                </TableRow>
              )
            })}     
        </TableBody>     
      } 
    </StickyTable>
  )
}

export default DepartmentListing